import type { ReactNode } from 'react';
import { cx } from './cx';

export interface SkeletonProps {
  className?: string;
  /** Convenience for a run of text lines of decreasing width. */
  lines?: number;
}

/**
 * A placeholder shape, not a spinner: the page keeps its layout while data
 * arrives, so nothing jumps when it does. Ground-coloured bars, square, no
 * shimmer.
 */
export function Skeleton({ className, lines }: SkeletonProps) {
  if (lines && lines > 0) {
    return (
      <div className="flex flex-col gap-3" aria-hidden="true">
        {Array.from({ length: lines }).map((_, i) => (
          <div key={i} className={cx('h-3 bg-paper-deep', i === lines - 1 ? 'w-2/3' : 'w-full')} />
        ))}
      </div>
    );
  }
  return <div aria-hidden="true" className={cx('h-4 w-full bg-paper-deep', className)} />;
}

/** Wrap a loading region so assistive tech is told something is coming. */
export function SkeletonRegion({ label = 'Loading', children }: { label?: string; children: ReactNode }) {
  return (
    <div role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">{label}</span>
      {children}
    </div>
  );
}
